export default "__VITE_ASSET__dc40279b__"